<template>
  <div>
    <h3>Content categories</h3>

    <div
      v-if="isLoading"
      class="text-center pt-3"
    >
      <b-spinner label="Loading..." />
    </div>
    <template v-else>
      <div class="custom-search d-flex justify-content-between flex-wrap">
        <b-form-group>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </b-form-group>
        <b-form-group>
          <b-button
            variant="primary"
            class="mx-1 float-right"
            size="sm"
            @click="openModal(null)"
          >
            <span>Add content category</span>
          </b-button>
        </b-form-group>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="filteredRows"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template #table-row="props">
          <span
            v-if="props.column.field === 'action'"
            class="action-link-group"
          >
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
              right
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle"
                />
              </template>
              <b-dropdown-item @click="openModal(props.row)">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>View / Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteRow(props.row)">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
          <DatatableCellValue
            v-else
            :field="props.column.field"
            :value="props.formattedRow[props.column.field]"
          />
        </template>

        <template #pagination-bottom="props">
          <TablePagination
            :value="1"
            :total-rows="props.total"
            :per-page="pageLength"
            @input="(value) => props.pageChanged({ currentPage: value })"
            @per-page-change="(n) => { pageLength = n; props.perPageChanged({ currentPerPage: n }) }"
          />
        </template>
      </vue-good-table>
    </template>

    <ManageContentCategory
      :click-date="clickDate"
      :record="record"
    />
  </div>
</template>

<script>
import 'vue-good-table-next/dist/vue-good-table-next.css'
import { VueGoodTable } from 'vue-good-table-next'
import {
  BButton,
  BDropdown,
  BDropdownItem,
  BFormGroup,
  BFormInput,
  BSpinner,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import TablePagination from '@/views/Components/Elements/TablePagination.vue'
import DatatableCellValue from '@/views/Components/Elements/DatatableCellValue.vue'
import { toastFailure, toastSuccess } from '@/libs/toastification'
import ManageContentCategory from '@/views/Modules/crtcreator/Components/ManageContentCategory.vue'

export default {
  components: {
    TablePagination,
    DatatableCellValue,
    ManageContentCategory,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormGroup,
    BFormInput,
    BSpinner,
    VueGoodTable,
  },
  data() {
    return {
      record: null,
      clickDate: null,
      isLoading: true,
      searchTerm: '',
      pageLength: 25,
      columns: [
        { label: 'Name', field: 'name' },
        { label: 'Description', field: 'description' },
        { label: 'Hashtags', field: 'hashtags' },
        { label: 'Actions', field: 'action', thClass: 'text-center', tdClass: 'text-center', sortable: false },
      ],
    }
  },
  computed: {
    ...mapGetters({
      items: 'crtcreator/contentCategories/items',
    }),
    filteredRows() {
      const keyword = String(this.searchTerm || '').trim().toLowerCase()
      const rows = (this.items || []).map((row) => this.mapRow(row))
      if (!keyword) return rows
      const fields = ['name', 'description', 'hashtags']
      return rows.filter((row) => fields.some((field) => String(row[field] ?? '').toLowerCase().includes(keyword)))
    },
  },
  async mounted() {
    try {
      await this.loadItems()
    } catch (e) {
      toastFailure('Can not load content categories')
    }
    this.isLoading = false
  },
  methods: {
    ...mapActions({
      loadItems: 'crtcreator/contentCategories/loadItems',
      deleteItem: 'crtcreator/contentCategories/deleteItem',
    }),
    mapRow(row) {
      return { ...row }
    },
    openModal(row) {
      this.record = row
      this.clickDate = new Date()
    },
    deleteRow(row) {
      this.$swal({
        title: 'Are you sure?',
        text: 'This content category will be deleted.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
      }).then((result) => {
        if (!result.isConfirmed) return
        this.deleteItem(row.id)
          .then(() => toastSuccess('Deleted'))
          .catch(() => toastFailure('Failed to delete'))
      })
    },
  },
}
</script>
